import useOpenTask from "./useOpenTask";
import useIsInappWebview from "./useIsInappWebview";
import { sendMessage } from "../utils/webview";

export default function useOpenPlanUpgrade(isFromHome?: {
  isFromHome: boolean;
}) {
  const openPlanUpgrade = useOpenTask({
    taskKey: `plan-upgrade`,
    params: isFromHome?.isFromHome ? { from: "home" } : undefined,
  });

  const isInappWebview = useIsInappWebview();

  return () => {
    if (isInappWebview) {
      sendMessage(
        JSON.stringify({
          event: "open_screen",
          params: {
            url: `${window.location.origin}/plan-upgrade${isFromHome?.isFromHome ? `?from=home` : ``}`,
            type: "card",
            gestureEnabled: true,
            animation: "default",
            replace: false,
          },
        })
      );
      return;
    }

    openPlanUpgrade();
  };
}
